import Repository, {
  ExtendedAxiosRequestConfig,
} from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { TaskedEndpointResponse } from "@shared/services/loaders/api";
import { taskLoader } from "@shared/services/loaders/task-loader";

export type UserRefundProtectionMetadataQueryParamsSerializer = {
  transaction_id: string;
};

export type RefundProtectionMetadataType = {
  faq_url: string;
  helpcenter_email: string;
  refund_request_url: string;
  cancellation_url: string;
  certificate_url: string;
  policy_pdf: string;
};

export default class UserBasedRefundProtectionRepository extends Repository<{
  //
}> {
  public readonly repositoryName = "UserBasedRefundProtectionRepository";

  public readonly endpoint = "api/user/refund-protection";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      metadata: `metadata`,
    };
  }

  public async metadata(
    params: UserRefundProtectionMetadataQueryParamsSerializer,
    config: ExtendedAxiosRequestConfig = {}
  ): Promise<RefundProtectionMetadataType> {
    const { data } = await this.request<
      TaskedEndpointResponse | RefundProtectionMetadataType
    >(this.buildUrl("metadata"), {
      method: "GET",
      params,
      ...config,
    });

    // Check if response contains job_id (async task)
    if ("job_id" in data && typeof data.job_id === "string") {
      const result = await taskLoader(data.job_id);
      return result.data as unknown as RefundProtectionMetadataType;
    }

    // Direct response (no async task)
    return data as RefundProtectionMetadataType;
  }
}
